import { render, staticRenderFns } from "./person-center.vue?vue&type=template&id=7e62e93a"
import script from "./person-center.vue?vue&type=script&lang=js"
export * from "./person-center.vue?vue&type=script&lang=js"
import style0 from "./person-center.vue?vue&type=style&index=0&id=7e62e93a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports